var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_59658_1032",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_59658_1032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 19C13.1 19 14.0417 18.6083 14.825 17.825C15.6083 17.0416 16 16.1 16 15V11C16 9.89998 15.6083 8.95831 14.825 8.17498C14.0417 7.39164 13.1 6.99998 12 6.99998C10.9 6.99998 9.95833 7.39164 9.175 8.17498C8.39167 8.95831 8 9.89998 8 11V15C8 16.1 8.39167 17.0416 9.175 17.825C9.95833 18.6083 10.9 19 12 19ZM10.1537 15.75H13.8462V14.25H10.1537V15.75ZM10.1537 11.75H13.8462V10.25H10.1537V11.75ZM12 20.5C11.0065 20.5 10.0889 20.2557 9.24725 19.7672C8.40558 19.2787 7.73725 18.6063 7.24225 17.75H4.5V16.25H6.677C6.57567 15.8398 6.52083 15.4247 6.5125 15.0047C6.50417 14.5849 6.5 14.1666 6.5 13.75H4.5V12.25H6.5C6.5 11.827 6.501 11.4055 6.503 10.9855C6.50483 10.5656 6.56283 10.1538 6.677 9.74998H4.5V8.24998H7.24225C7.48208 7.84098 7.76542 7.46823 8.09225 7.13173C8.41925 6.79523 8.79367 6.51156 9.2155 6.28073L7.51925 4.55373L8.55375 3.51923L10.6848 5.64998C11.1129 5.51931 11.5462 5.45397 11.9845 5.45397C12.423 5.45397 12.8563 5.51931 13.2845 5.64998L15.4653 3.51923L16.5 4.55373L14.773 6.28073C15.1948 6.51156 15.5712 6.79264 15.902 7.12398C16.2327 7.45548 16.5179 7.83081 16.7578 8.24998H19.5V9.74998H17.323C17.4372 10.1538 17.4952 10.5656 17.497 10.9855C17.499 11.4055 17.5 11.827 17.5 12.25H19.5V13.75H17.5C17.5 14.1666 17.4958 14.5849 17.4875 15.0047C17.4792 15.4247 17.4243 15.8398 17.323 16.25H19.5V17.75H16.7578C16.2628 18.6063 15.5944 19.2787 14.7527 19.7672C13.9111 20.2557 12.9935 20.5 12 20.5Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugReportIcon);
export default __webpack_public_path__ + "static/media/bugReportIcon.a2012c0fd7d4389be01eae0e2c8012bc.svg";
export { ForwardRef as ReactComponent };